import React, { useEffect } from 'react';
import { useAccount, useConnect } from 'wagmi';
import { useAuth } from '#components/auth/AuthProvider';
import { ImageAsset } from '@packages/common-ui/components/image';
import { isWalletAddress } from '@packages/common-ui/types/wallet';
import { CtaButton } from '@packages/common-ui/components/CtaButton';
type WithSignInProps = {
  requiresSignIn: true;
  onSignedIn?: () => void;
  onWalletConnected?: never;
};
type WithoutSignInProps = {
  requiresSignIn?: false;
  onWalletConnected: () => void;
  onSignedIn?: never;
};
export const ConnectWallet = ({
  requiresSignIn,
  onWalletConnected,
  onSignedIn
}: WithSignInProps | WithoutSignInProps) => {
  const {
    isAuthenticated,
    getAccessToken
  } = useAuth();
  const {
    address: walletAddress,
    isConnecting
  } = useAccount();
  const {
    connectors,
    connect
  } = useConnect();
  useEffect(() => {
    if (isWalletAddress(walletAddress) && onWalletConnected !== undefined) {
      onWalletConnected();
    }
  }, [onWalletConnected, walletAddress]);
  useEffect(() => {
    if (requiresSignIn && isWalletAddress(walletAddress) && isAuthenticated() && onSignedIn !== undefined) {
      onSignedIn();
    }
  }, [isAuthenticated, onSignedIn, requiresSignIn, walletAddress]);
  const renderAuthenticate = () => <div className="flex h-screen w-screen flex-col items-center justify-center gap-y-10" style={{
    animationDelay: '650ms'
  }}>
      <h2 className="font-coanda text-6xl uppercase">Sign your wallet</h2>
      <span className="font-chakra-petch text-lg">No gas fees will apply</span>
      <CtaButton variant="primary" size="large" onClick={() => getAccessToken()} innerClassName="px-10">
        Sign
      </CtaButton>
    </div>;
  const renderConnectWallet = () => <div className="flex h-screen w-screen flex-col items-center justify-center gap-y-10" style={{
    animationDelay: '650ms'
  }}>
      <h2 className="font-coanda text-6xl uppercase">Connect your wallet</h2>
      <span className="font-chakra-petch text-lg">
        You need to connect your wallet before proceeding.
      </span>
      <div className="flex w-full justify-center gap-x-10">
        {connectors.map(connector => <CtaButton key={connector.name} variant="primary" size="large" innerClassName="relative px-14" disabled={isConnecting} onClick={() => connect({
        connector
      })}>
            <ImageAsset src={`/assets/wallet/${connector.name}.webp`} alt={connector.name} className="absolute left-2 top-1/2 h-6 w-6 -translate-y-1/2" />
            {connector.name}
          </CtaButton>)}
      </div>
    </div>;
  return <div className="h-screen w-screen bg-[url(/assets/vessel-hatching/landingBg.webp)] bg-cover bg-center">
      {!isWalletAddress(walletAddress) && !isAuthenticated() && renderConnectWallet()}
      {isWalletAddress(walletAddress) && !isAuthenticated() && renderAuthenticate()}
    </div>;
};